import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b2b11e10&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=b2b11e10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b11e10",
  null
  
)

export default component.exports